const n = {
  name: "BankIn",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.3015 0H9.69849L3 4.44333V7H5V13H3V15H21V13H18.99V7H21V4.44333L14.3015 0ZM16.99 7V13H14.99V7H16.99ZM12.99 7V13H11V7H12.99ZM9 7V13H7V7H9ZM5.7789 5L10.3015 2H13.6985L18.2211 5H5.7789Z" fill="currentColor"/>
<path d="M11.9999 16.5858L16.4141 21L14.9999 22.4142L13 20.4143V24H11V20.4141L8.99991 22.4142L7.58569 21L11.9999 16.5858Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as BankIn
};
